import React from "react";
import { Button } from "wbm-inputs";

type HeaderProps = {
    className: string;
    text: string;
    qty: number;
};

export const HeaderText = ({ ...props }: HeaderProps) => {
    let className = "page-header-text";
    if (props.className) {
        className += " " + props.className;
    }
    return (
        <div className={className}>
            <div className="font-weight-bold">{props.text}</div>
            {props.qty ? (
                <span className="header-qty">({props.qty} Items)</span>
            ) : null}
        </div>
    );
};

type CardProps = {
    className?: string;
    text: string;
    linkAddress?: string;
    linkText?: string;
    onLinkClick?: () => void;
};

export const CardHeader = ({ ...props }: CardProps) => {
    let className = "card-header-text font-weight-bold";
    if (props.className) {
        className += " " + props.className;
    }
    return (
        <div className={className}>
            <div className="font-weight-bold">
                {props.text}
                {props.linkText ? (
                    props.linkAddress ? (
                        <a href={props.linkAddress} target="_blank" className="body wbm-button btn btn-link medium" rel="noopener">
                            {props.linkText}
                        </a>
                    ) : (
                        <Button className="wbm-button btn btn-link medium" onClick={props.onLinkClick}>
                            {props.linkText}
                        </Button>
                    )
                ) : null}
            </div>
        </div>
    );
};
